export default {
  'notFound.title': 'The page you are looking for does not exist!',
  'notFound.subtitle': 'If you are having any problems, please contact Btime support'
}
